import { Platform, StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { Background } from 'src/theme-v2/background';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { brand, neutrals, text } from 'src/theme/colors';

const sharedStyles = StyleSheet.create({
  modalContainer: {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    backgroundColor: neutrals.neutralGrays.crystal,
    borderRadius: 0,
    padding: 0,
    margin: 0,
  },
  modalContent: {
    flex: 1,
    padding: 0,
    backgroundColor: neutrals.neutralGrays.crystal,
  },
  contentWrapper: {
    flex: 1,
    backgroundColor: neutrals.neutralGrays.crystal,
  },
  headerElement: {
    width: '33%',
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 12,
  },
  headerCenter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerRight: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 16,
  },
  gridButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: brand.main.water,
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 38,
    width: 145,
    borderRadius: 24,
    paddingHorizontal: 15,
    paddingVertical: 8,
    gap: 8,
    backgroundColor: neutrals.white,
    ...(Platform.OS === 'web' &&
      ({
        boxShadow: '9px 4px 19.4px 0 rgba(0,0,0,0.08)',
      } as any)),
  },
  backButtonText: {
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 24, //16* 150%
    color: neutrals.neutralGrays.tarmac,
  },
  mainContent: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexGrow: 0,
    paddingVertical: 40,
  },
  productContainer: {
    flex: 1,
    width: '100%',
    maxWidth: 800,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 24,
    gap: 24,
  },
  topToolsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24,
    paddingBottom: 24,
  },
  productWrapper: {
    flex: 1,
    width: '100%',
    maxHeight: '70%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20,
  },
  bottomToolsContainer: {
    maxWidth: 350,
    paddingTop: 24,
  },
  undoRedoContainer: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'center',
  },

  iconButtonWrapperUndoRedo: {
    padding: 8,
    width: 38,
    height: 38,
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconButtonWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  sliderZoomContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  divider: {
    height: 24,
    borderLeftWidth: 1,
    borderLeftColor: neutrals.neutralGrays.aluminium,
  },
  rightIconsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  gridButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    padding: 12,
    borderRadius: 12,
    backgroundColor: neutrals.white,
    width: 44,
    height: 44,
  },
  gridIcon: {
    width: 18,
    height: 18,
    color: text.color.interactive,
  },
  button: {
    justifyContent: 'center',
    display: 'flex',
    flex: 1,
    minHeight: 38,
    minWidth: 214,
    borderRadius: 100,
    backgroundColor: neutrals.white,
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      spreadRadius: 2,
      color: brand.main.variations['lighterWater-2'],
    }),
    borderColor: brand.main.water,
    borderWidth: 1,
  },
  buttonInner: {
    height: '100%',
    width: '100%',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
    paddingHorizontal: 24,
    paddingVertical: 7,
  },
  counterText: {
    ...textLatoStyleDS.BodyRegularSm,
    color: ColorTypography.TextColorPrimary,
  },
});

export const styleDesktop = StyleSheet.create({
  ...sharedStyles,
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 16,
    ...Background.BackgroundColorBlur,
  },
  modalTitle: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 26,
  },
  ctaWrapper: {},
  counter: {
    ...Background.BackgroundColorBlur,
    paddingHorizontal: 12,
    paddingVertical: 7,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const styleMobile = StyleSheet.create({
  ...sharedStyles,
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 14,
    ...Background.BackgroundColorBlur,
  },
  modalTitle: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
  },
  ctaWrapper: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    backgroundColor: `${neutrals.white}D9`,
    padding: 24,
    paddingTop: 16,
    paddingBottom: 24,
  },
  counter: {
    paddingHorizontal: 16,
    paddingVertical: 7,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 16,
    ...Background.BackgroundColorBlur,
  },
});
